import React from 'react';

export default class DropdownList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		console.log('DropdownList', this.props);

		let optionsList = [];

		Object.keys(this.props.data).forEach((key) => {
			optionsList.push(
				<option className="select-item" value={key} key={key}>
					{this.props.data[key]}
				</option>
			);
		});

		return (
			<div className="DropdownList">
				<form>
					<select
						className="select-box"
						name={this.props.name}
						value={this.props.value}
						onChange={this.props.onChange}
					>
						{optionsList}
					</select>
				</form>
			</div>
		);
	}
}
